import BasicModal from '../../components/modals/BasicModal';
import { FolderInviteForm } from './FolderInviteForm';

/**
 * Invite colleagues to a folder by email — the folder-page entry point. Thin wrapper around the
 * shared FolderInviteForm (the My Resources share modal uses the same form); auto-closes shortly
 * after invites send.
 */
export const InviteToFolderModal = ({ collectionId, folderName, showModal, setShowModal }) => (
  <BasicModal title='Invite to this folder' showModal={showModal} setShowModal={setShowModal}>
    <div className='mt-4'>
      <FolderInviteForm
        collectionId={collectionId}
        folderName={folderName}
        onInvited={() => setTimeout(() => setShowModal(false), 1800)}
      />
    </div>
  </BasicModal>
);
